import React from 'react';

import Icon from '../../../components/AppIcon';

const BrandHeader = () => {
  return (
    <div className="text-center mb-8">
      <div className="flex items-center justify-center mb-6">
        <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center">
          <Icon name="Hexagon" size={40} color="var(--color-primary)" strokeWidth={2} />
        </div>
      </div>
      
      <h1 className="text-3xl font-bold text-foreground mb-2">
        Welcome to Bee Wise
      </h1>
      <p className="text-muted-foreground text-lg">
        Your intelligent onboarding companion
      </p>
    </div>
  );
};

export default BrandHeader;